// extracted by mini-css-extract-plugin
export var attachButton = "_j8-8";
export var sendButton = "_j8-2";
export var sendDisabled = "_j8-4";
export var sendEnabled = "_j8-3";
export var sendIcon = "_j8-6";
export var sendIconDisabled = "_j8-7";
export var sendStreaming = "_j8-5";
export var textarea = "_j8-1";
export var wrapper = "_j8-0";